module.exports = __webpack_public_path__ + "img/homepage-search.253df2b.svg";